import { render } from "./KinkFilterSelect.vue?vue&type=template&id=67977696&scoped=true&ts=true"
import script from "./KinkFilterSelect.vue?vue&type=script&lang=ts"
export * from "./KinkFilterSelect.vue?vue&type=script&lang=ts"

import "./KinkFilterSelect.vue?vue&type=style&index=0&id=67977696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67977696"]])

export default __exports__